export class Contact {
  name: string = '';
  email: string = '';
  phone: string = '';
  subject: string = ''; 
  message: string = '';
  countryCode: string = '';
  countryName: string = '';
}